import { useEffect } from 'react';
import { Form, Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions/adminActions';
import { bindActionCreators } from 'redux';

const UserGroupDropDown = props => {
  useEffect(() => {
    props.loadUserGroups();
  }, []);

  return (
    <Form.Field error={Boolean(props.error)}>
      <label htmlFor={props.name}>{props.label}</label>
      <Dropdown
        fluid
        search
        clearable
        selection
        key={props.id ? props.id + '-' + props.name : props.name}
        options={props.options || []}
        id={props.name}
        label={props.label}
        name={props.name}
        value={props.value ? props.value : props.options[0].value}
        onChange={(e, d) => props.formik.setFieldValue(d.name, d.value)}
      />
    </Form.Field>
  );
};

const mapStateToProps = state => ({
  options: state.admin.groupOptions,
});

const mapDispatchToProps = dispatch => ({
  loadUserGroups: bindActionCreators(actions.getGroups, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupDropDown);
